import * as Yup from 'yup';
import i18n from 'i18next';

const text_comment_required = i18n.t('validation.comment_required');
const text_comment_min = i18n.t('validation.comment_min');
const text_comment_invalid = i18n.t('validation.comment_invalid');
const text_email_invalid = i18n.t('validation.email_invalid');


const schemaReportForm = Yup.object().shape({
    comment: Yup.string()
        .required(text_comment_required)
        .min(3, ({ min }) => i18n.t('validation.comment_min', { minLength: min }))
        .test('is-valid-description', text_comment_invalid, function (value) {
            return !!value;
        }),
    email: Yup.string()
        .notRequired()
        .email(text_email_invalid),
        // .test('valid-email', text_email_invalid, function (value) {
        //     if (!value) return true;
        //     return emailRegExp.test(value);
        // }),
});

export default schemaReportForm;